import Nav from "./Nav";

const Header = () => {
  return (
    <header className="flex justify-center">
      <Nav></Nav>
    </header>
  );
};

export default Header;
